import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import { BASE_URL } from "@/constants/constants";
import { literals } from "@/constants/literals";
import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CloseReceptionOrderModal from "./components/CloseReceptionOrderModal";
import GroupDetail from "@/pages/capture/components/GroupDetail";
import useReceptionDataStore from "@/store/useReceptionData.store";
import ReceptionOrderHeader from "../components/ReceptionOrderHeader";

const ReceptionResumePage = () => {
  const [viewModal, setViewModal] = useState(false);
  const { receptionGroupData } = useReceptionDataStore();
  const navigate = useNavigate();

  const handleOnAddMore = () => {
    navigate(`${BASE_URL}/capture/reception/new-group`);
  };

  const onClose = () => {
    setViewModal(false);
  };

  const noGroupsInData = useMemo(
    () => !receptionGroupData || receptionGroupData.length === 0,
    [receptionGroupData],
  );

  const handleOnContinue = () => {
    if (!noGroupsInData) {
      setViewModal(true);
    }
  };

  return (
    <div className="min-h-fulldpx flex flex-col justify-between bg-ib-pt-color-white">
      <div className="flex-1">
        <ReceptionOrderHeader inResumePage />
        <div className="p-4 md:px-14 md:py-6">
          <ul className="w-full flex flex-col gap-4 md:flex-row md:flex-wrap items-stretch">
            {receptionGroupData.map((group) => {
              return (
                <li
                  key={group.id}
                  className="w-full md:w-[calc((100%-16px)/2)] lg:w-[calc((100%-32px)/3)]"
                >
                  <GroupDetail group={group} stand="reception" />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <div className="w-full p-4 md:px-0 flex flex-col md:flex-row md:justify-around gap-4 md:gap-0 border-t border-ib-pt-color-gray-300 md:items-center">
        <div className="md:capture-button">
          <SecondaryButton
            size="medium"
            colour="red"
            label={
              !noGroupsInData
                ? literals.uploadMorePhotos
                : literals.uploadPhotoGroup
            }
            onClick={handleOnAddMore}
          />
        </div>
        <div className="md:capture-button">
          <PrimaryButton
            size="medium"
            label={literals.continue}
            colour="red"
            type="submit"
            onClick={handleOnContinue}
            disabled={noGroupsInData}
          />
        </div>
      </div>
      <CloseReceptionOrderModal
        onClose={onClose}
        viewModal={viewModal}
        noGroupsInData={noGroupsInData}
      />
    </div>
  );
};

export default ReceptionResumePage;
